import { render, staticRenderFns } from "./IconCurrencyYenOutline.vue?vue&type=template&id=4b115238"
import script from "./IconCurrencyYenOutline.vue?vue&type=script&lang=js"
export * from "./IconCurrencyYenOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports